import { Container, IDestroyOptions } from "@pixi/display";
import { Ticker } from "@pixi/ticker";
import { Text, TextStyle } from "@pixi/text";
import { GameViewController } from "../../controllers/GameViewController";
import { getDefaultFontFamily } from "../../../common/TextUtils";

export class AdTimer extends Container {
    private timeText: Text;
    private currentTime: number;
    private readonly timeMs: number;
    private readonly ticker: Ticker;
    private readonly timeMsToShowText: number;

    public constructor(
        private readonly gameViewController: GameViewController
    ) {
        super();
        this.ticker = Ticker.shared;
        this.timeMs = 180000;
        this.timeMsToShowText = 3000;
        this.timeText = new Text("",
            new TextStyle(
                {
                    fontFamily: getDefaultFontFamily(),
                    fontSize: 60,
                    fill: "#804409",
                    align: "center"
                })
        );
        this.timeText.anchor.x = 0.5;
        this.addChild(this.timeText);
        this.currentTime = this.timeMs;
        this.ticker.add(this.timerUpdater, this);
    }

    private timerUpdater(): void {
        this.currentTime -= this.ticker.elapsedMS;
        if (this.currentTime <= this.timeMsToShowText) {
            this.timeText.text = `${Math.round(this.currentTime / 1000)}`;
        }
        if (this.currentTime < 0) {
            this.timeText.text = "";
            this.currentTime = this.timeMs;
            this.gameViewController.watchMidrollAd();
        }
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.ticker.remove(this.timerUpdater, this);
        super.destroy(options);
    }
}